module.exports = __webpack_public_path__ + "img/one.bb621e76.png";